import { Injectable } from '@angular/core';
declare const SXC_VERSION: string

interface Scripts {
  name: string
  src: string
}

interface ScriptLoadResult {
  script: string
  loaded: boolean
  status: string
}

export const ScriptStore: Scripts[] = [
  { name: 'sxc-api', src: '/Sxc/core/js/2sxc.api.min.js?cacheBreak=' + SXC_VERSION },
  { name: 'sxc-inpage', src: '/Sxc/core/dist/inpage/inpage.min.js?cacheBreak=' + SXC_VERSION }
]

// Service to inject JavaScript files dynamically
// source: https://stackoverflow.com/a/42766146/4049371
@Injectable({
  providedIn: 'root'
})
export class ScriptService {

  private scripts: { [key: string]: { loaded: boolean, src: string } } = {}

  constructor() {
    ScriptStore.forEach(script => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      }
    })
  }

  load(...scripts: string[]): Promise<ScriptLoadResult[]> {
    const promises: Promise<ScriptLoadResult>[] = []
    scripts.forEach(script => promises.push(this.loadScript(script)))
    return Promise.all(promises)
  }

  loadScript(name: string): Promise<ScriptLoadResult> {
    return new Promise(resolve => {
      // resolve if already loaded
      if (this.scripts[name].loaded)
        resolve({ script: name, loaded: true, status: 'Already Loaded' })
      else {
        // load script
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = this.scripts[name].src

        script.onload = () => {
          this.scripts[name].loaded = true
          resolve({ script: name, loaded: true, status: 'Loaded' })
        }

        script.onerror = () => resolve({ script: name, loaded: false, status: 'Loaded' })
        document.getElementsByTagName('head')[0].appendChild(script)
      }
    })
  }
}
